import { TREATMENT_INSTANCE_SORTING_SET } from '../../constants/types';

export function setTreatmentInstanceSorting(sorting) {
  return {
    type: TREATMENT_INSTANCE_SORTING_SET,
    sorting,
  };
}
